import React from "react";

function MeetUp() {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "100%",
        padding: "2rem",
        textAlign: "center",
        color: "#555",
      }}
    >
      <h1 style={{ fontSize: "2.5rem", marginBottom: "1rem" }}>
        🚧 Under Construction 🚧
      </h1>
      <p style={{ fontSize: "1.25rem" }}>
        This page is coming soon. We’re working hard to get things ready— check
        back shortly!
      </p>
    </div>
  );
}

export default MeetUp;
